import React from 'react'

export default function Footer(): React.ReactElement {
    return (
        <footer className="text-center p-2">
            <span className='text-gray font-[Acumin-Pro] text-sm md:text-base'>
                All rights reserved to @2025. Willow Yard
            </span>
        </footer>
    );
};